class DetectBackground {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._triggerElems = document.querySelectorAll('[data-color-trigger]')
    }

    init () {
        window.addEventListener('scroll', e => {
            this.detectBackground()
        }, { passive: true })
        this.detectBackground()
    }

    detectBackground () {
        let overlapsWithOne = false
        for (let element of this._triggerElems) {
            if (this.overlapsWith(element)) {
                overlapsWithOne = true
                this.switchColor(element.dataset.colorTrigger)
            }
        }
        if (!overlapsWithOne) {
            this.switchColor('dark')
        }
    }

    switchColor (newColor) {
        for (let elemClass of this._elem.classList) {
            if (elemClass.includes('color-state--')) {
                this._elem.classList.remove(elemClass)
            }
        }
        this._elem.classList.add(`color-state--${newColor}`)
    }

    overlapsWith (elem) {
        let socialRect = this._elem.getBoundingClientRect()
        let otherRect = elem.getBoundingClientRect()
        return (otherRect.top <= socialRect.top + socialRect.height && otherRect.top + otherRect.height > socialRect.top) && (otherRect.left <= socialRect.left + socialRect.width && otherRect.left + otherRect.width > socialRect.left)
    }
}

export default DetectBackground



// WEBPACK FOOTER //
// ./resources/scripts/components/DetectBackground.js